export const sections = [
  {
    id: 'entry',
    range: [0.06, 0.18],
    lines: [
      { text: 'Everyone says they use data.', delay: 0, style: 'large' },
      { text: "Most of them don't.", delay: 300, style: 'large' },
    ],
  },
  {
    id: 'disruption',
    range: [0.18, 0.30],
    lines: [
      { text: 'They build dashboards.', delay: 0, style: 'medium-snap' },
      { text: 'And stop there.', delay: 200, style: 'medium-snap' },
    ],
  },
  {
    id: 'shift',
    range: [0.30, 0.42],
    lines: [
      { text: "I don't care about dashboards.", delay: 0, style: 'large-hold' },
      { text: 'I care about what changes after.', delay: 300, style: 'large' },
    ],
  },
  {
    id: 'break-rhythm',
    range: [0.42, 0.54],
    lines: [
      { text: 'Most people see the pattern.', delay: 0, style: 'stagger' },
      { text: 'I ask why', delay: 250, style: 'stagger' },
      { text: "it's there.", delay: 500, style: 'tiny-impact' },
    ],
  },
  {
    id: 'fragments',
    range: [0.54, 0.66],
    lines: [
      { text: '80.56% of footfall.', delay: 0, style: 'scatter', position: 'top-left' },
      { text: 'Evening. Every time.', delay: 200, style: 'scatter', position: 'top-right' },
      { text: 'Nobody asked why.', delay: 450, style: 'scatter', position: 'mid-left' },
      { text: 'I did.', delay: 650, style: 'scatter', position: 'mid-right' },
      { text: "That's the gap", delay: 900, style: 'scatter', position: 'bottom-left' },
      { text: 'between data and insight.', delay: 1100, style: 'scatter', position: 'bottom-right' },
    ],
  },
  {
    id: 'depth',
    range: [0.66, 0.75],
    lines: [
      { text: "Things don't fail loudly.", delay: 0, style: 'slow' },
      { text: 'They drift.', delay: 300, style: 'slow' },
      { text: 'And no one notices.', delay: 600, style: 'slow' },
    ],
  },
  {
    id: 'control',
    range: [0.75, 0.82],
    lines: [
      { text: 'I notice.', delay: 0, style: 'center-scale' },
    ],
  },
  {
    id: 'philosophy',
    range: [0.82, 0.89],
    lines: [
      { text: "Data doesn't matter.", delay: 0, style: 'large' },
      { text: 'Until it moves something.', delay: 300, style: 'large' },
    ],
  },
  {
    id: 'final-filter',
    range: [0.89, 0.94],
    lines: [
      { text: 'Most portfolios show what they did.', delay: 0, style: 'medium' },
      { text: 'This shows how I think.', delay: 300, style: 'medium' },
    ],
  },
  {
    id: 'exit',
    range: [0.94, 0.97],
    lines: [
      { text: "It's not for everyone.", delay: 0, style: 'exit' },
    ],
  },
];

export const hiddenLayer = {
  line1: "If you're still here",
  line2: "you're looking for something.",
  buttonText: 'Open Resume',
  resumeUrl: '/resume.pdf',
  linkedinUrl: 'https://www.linkedin.com/in/rohanvshetty2003/',
  email: 'rohanshetty4266@gmail.com',
  name: 'Rohan V Shetty',
};
